import React, { forwardRef } from "react";

import { twMerge } from "tailwind-merge";

import style from "./style.module.scss";

const LoaderLine = () => {
  return (
    <div className={style.loadingContainer}>
      <div className={style.loadingBackground}>
        <div className={style.item_right}>
          <div className={style.row1}></div>
          <div className={style.row2}></div>
          <div className={style.row3}></div>
          <div className={style.row4}></div>
        </div>
      </div>
    </div>
  );
};

export const LoaderSingleLine = ({
  loadingContainerClassName,
  loadingBackgroundClassName,
}: any) => {
  return (
    <div
      className={twMerge(
        style.loadingContainer,
        "!m-0 !h-[55px] md:!h-[33px] rounded",
        loadingContainerClassName
      )}
    >
      <div
        className={twMerge(
          style.loadingBackground,
          "!h-[55px] md:!h-[33px]",
          loadingBackgroundClassName
        )}
      >
        <div className={style.row1}></div>
      </div>
    </div>
  );
};

export const LoaderBox = ({ className }: { className?: string }) => {
  return (
    <div className={twMerge(style.loadingContainer, className)}>
      <div className={style.loadingBackground}></div>
    </div>
  );
};

export const LoaderItem = () => {
  return (
    <div className={style.loadingContainer}>
      <div className={style.loadingBackground}>
        <div className={style.item_left}>
          <div className={style.top}></div>
          <div className={style.bottom}></div>
          <div className={style.left}></div>
        </div>
        <div className={style.item_right}>
          <div className={style.row1}></div>
          <div className={style.row2}></div>
          <div className={style.row3}></div>
          <div className={style.row4}></div>
        </div>
      </div>
    </div>
  );
};

const LoaderChart = () => {
  return (
    <div className={twMerge(style.chart)}>
      <div className={twMerge(style.noChartData, "relative")}>
        <div className={style.yAxis}></div>
        <div className={style.xAxis}></div>
        <div className={style.bars}>
          <div className={style.overlay}></div>
          <div className={twMerge(style.bar, style.bar0)}></div>
          <div className={twMerge(style.bar, style.bar1)}></div>
          <div className={twMerge(style.bar, style.bar2)}></div>
          <div className={twMerge(style.bar, style.bar3)}></div>
          <div className={twMerge(style.bar, style.bar4)}></div>
          <div className={twMerge(style.bar, style.bar5)}></div>
          <div className={twMerge(style.bar, style.bar6)}></div>
          <div className={twMerge(style.bar, style.bar7)}></div>
          <div className={twMerge(style.bar, style.bar8)}></div>
          <div className={twMerge(style.bar, style.bar9)}></div>
          <div className={twMerge(style.bar, style.bar10)}></div>
          <div className={twMerge(style.bar, style.bar11)}></div>
          <div className={twMerge(style.bar, style.bar12)}></div>
          <div className={twMerge(style.bar, style.bar13)}></div>
          <div className={twMerge(style.bar, style.bar14)}></div>
          <div className={twMerge(style.bar, style.bar15)}></div>
          <div className={twMerge(style.bar, style.bar16)}></div>
          <div className={twMerge(style.bar, style.bar17)}></div>
          <div className={twMerge(style.bar, style.bar18)}></div>
          <div className={twMerge(style.bar, style.bar19)}></div>
          <div className={twMerge(style.bar, style.bar20)}></div>
          <div className={twMerge(style.bar, style.bar21)}></div>
          <div className={twMerge(style.bar, style.bar22)}></div>
          <div className={twMerge(style.bar, style.bar23)}></div>
        </div>
      </div>
      <div
        className={twMerge(
          style.loadingBackground,
          "absolute top-0 bottom-0 right-0 left-0 mix-blend-overlay"
        )}
      ></div>
    </div>
  );
};

type LoaderComponentProps = {
  numberOfItems?: number;
  className?: string;
  type?: "paragraph" | "list" | "chart";
};

const LoaderComponent = (
  { numberOfItems = 3, className, type }: LoaderComponentProps,
  ref: React.ForwardedRef<HTMLDivElement>
) => {
  if (type === "paragraph") {
    return (
      <div ref={ref} className={className}>
        {Array.from({ length: numberOfItems }, (_, i) => i + 1).map((value) => (
          <LoaderLine key={value} />
        ))}
      </div>
    );
  }

  if (type === "chart") {
    return (
      <div ref={ref} className={className}>
        <LoaderChart />
      </div>
    );
  }

  return (
    <div ref={ref} className={className}>
      {Array.from({ length: numberOfItems }, (_, i) => i + 1).map((value) => (
        <LoaderItem key={value} />
      ))}
    </div>
  );
};

export const Loader = forwardRef(LoaderComponent);
